import Swiper, {Autoplay, Navigation} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

let slidersElements = null;
let initedSlider = {
    id: null,
    slider: null,
};

let eventBound = false;

export default function (sliderId) {
    // prepare all sliders
    if (!slidersElements) {
        slidersElements = document.querySelectorAll('[data-slider]');
    }
    prepareSliders(sliderId);

    // bind event listener
    if (!eventBound) {
        bindEventListener();
        eventBound = true;
    }

    processSliderId(sliderId);
}

function prepareSliders(sliderId) {
    slidersElements.forEach(sliderElement => {
        sliderElement.classList.toggle('active', sliderElement.dataset.slider === sliderId.replace('#', ''));
    });
}

function processSliderId(sliderId) {
    if (initedSlider.id === sliderId) {
        return;
    }

    if (initedSlider.slider) {
        initedSlider.slider.destroy();
    }

    initedSlider.slider = initSlider(sliderId);
    initedSlider.id = sliderId;
}

function bindEventListener() {
    window.addEventListener('aboutEvent', e => {
        const sliderId = `#slider-${e.detail.anchor}`;
        prepareSliders(sliderId);
        processSliderId(sliderId);
    })
}

function initSlider (sliderId) {
    Swiper.use([Autoplay, Navigation]);

    return new Swiper(sliderId, {
        autoplay: {
            delay: 5000
        },
        grabCursor: true,
        slidesPerView: 3,
        spaceBetween: 80,
        centeredSlides: true,
        loop: true, // requires number of slider >= slidesPerView * 2
        navigation: {
            nextEl: '#swiper-slider-button-next',
            prevEl: '#swiper-slider-button-prev'
        },
        breakpoints: {
            280: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            560: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 60
            },
            1080: {
                slidesPerView: 3,
                spaceBetween: 80
            }
        }
    });
}
